import { useContext } from 'react'
import AuthContext from '@/features/allauth/context/AllauthAuthContext'

const useAuth = () => useContext(AuthContext)

export default useAuth
